import { render, staticRenderFns } from "./LoginTransfer.vue?vue&type=template&id=0a283e51&scoped=true"
import script from "./LoginTransfer.vue?vue&type=script&lang=js"
export * from "./LoginTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a283e51",
  null
  
)

export default component.exports